export const defaultRoutes = [
  {
    path: '/',
    name: 'tours',
    component: () => import('@/pages/destinationGuides/ui/DestinationGuidesPage.vue'),
  },
  {
    path: '/experience/:slug/guides/',
    name: 'experience-guides',
    component: () => import('@/pages/destinationGuides/ui/DestinationGuidesPage.vue'),
    meta: {
      title: 'Tripster',
      soguName: 'experience-guides',
    },
  },
  {
    path: '/destinations/regions/:region/guides/',
    name: 'destination-region-guides',
    component: () => import('@/pages/destinationGuides/ui/DestinationGuidesPage.vue'),
    meta: {
      title: 'Tripster',
      soguName: 'experience-guides',
    },
  },
  {
    path: '/destinations/:country/guides/',
    name: 'destination-guides',
    component: () => import('@/pages/destinationGuides/ui/DestinationGuidesPage.vue'),
    meta: {
      title: 'Tripster',
      soguName: 'experience-guides',
    },
  },
];
